import USBNotification from "@usb-shield/react-notification";
import ContactUs from "./ContactUs";

const ReportNotAvailable = ({ hasMultipleMerchants }) => {
  const message = hasMultipleMerchants
    ? "No dashboards are currently available for the selected merchant. Please select a different merchant or check back later."
    : "No dashboards are currently available. Please check back later.";

  return (
    <div className="mt-2">
      <USBNotification
        status="info"
        roleType="alert"
        iconAssistiveText={{ label: "Information" }}
      >
        {message} <ContactUs />
      </USBNotification>
    </div>
  );
};

export default ReportNotAvailable;
